// /integrations page content. Status must match the code:
// deployment/api/google.mjs (scopes), deployment/api/providers.mjs (AI),
// deployment/api/bing.mjs (Bing read methods, own key only),
// deployment/api/clarity.mjs (Clarity Data Export, one token per site).

export const INTEGRATIONS_PAGE = {
  path: "/integrations",
  title: "Integrations: Search Console, GA4, Bing, Clarity and AI | SEO Signals",
  description: "SEO Signals connects to Google Search Console, Google Analytics 4, Bing Webmaster Tools and Microsoft Clarity with read-only access, and uses AI models to explain your data.",
  eyebrow: "INTEGRATIONS",
  h1: "What SEO Signals connects to",
  lead: "SEO Signals reads Google Search Console and GA4, plus Bing Webmaster Tools and Microsoft Clarity if you connect them, all with read-only access. Anthropic or OpenAI can explain the selected site’s reports after you explicitly permit sharing with that recipient. Reports remain available without AI sharing. It never writes to your accounts or your website.",
};

export const INTEGRATIONS = [
  {
    id: "search-console", name: "Google Search Console", status: "Connected", group: "Data sources",
    summary: "Search performance for the properties you choose.",
    reads: ["Queries, pages, clicks, impressions, click-through rate and average position", "Indexing information Google reports for the property"],
    access: "Read-only (webmasters.readonly)",
  },
  {
    id: "ga4", name: "Google Analytics 4", status: "Connected", group: "Data sources",
    summary: "What visitors do after they arrive.",
    reads: ["Landing pages, sessions, users and engagement", "The key events you have set up, such as enquiries, bookings or purchases"],
    access: "Read-only (analytics.readonly)",
  },
  {
    id: "google-sign-in", name: "Google sign-in", status: "Connected", group: "Account",
    summary: "Sign in with the Google account that can see your properties.",
    reads: ["Your name, email address and Google account identifier"],
    access: "openid, email and profile",
  },
  {
    id: "anthropic", name: "Anthropic Claude", status: "Connected", group: "AI models",
    summary: "Explains priorities and answers your questions in plain English.",
    reads: ["Your question and a summary of the selected property's data"],
    access: "Your own Anthropic API key, added in Settings, or SEO Signals' key where available",
  },
  {
    id: "openai", name: "OpenAI GPT", status: "Connected", group: "AI models",
    summary: "Explains the selected site’s connected reports after your explicit permission.",
    reads: ["Your question and a summary of the selected property's data"],
    access: "Your own OpenAI API key, added in Settings, or SEO Signals' key where available",
  },
  {
    id: "openrouter", name: "OpenRouter", status: "Unavailable", group: "AI models",
    summary: "Sharing Google-derived data through OpenRouter is unavailable until the actual serving recipient can be verified and disclosed.",
    reads: ["No Google-derived data is sent through these disabled routes"],
    access: "Adding an OpenRouter key does not enable sharing. Choose Anthropic or OpenAI with separate permission for each site and recipient.",
  },
  {
    id: "clarity", name: "Microsoft Clarity", status: "Connected", group: "Data sources",
    summary: "Where visitors rage click, hit dead ends or leave straight away, page by page.",
    reads: ["Daily sessions, quick backs, rage clicks, dead clicks, excessive scrolling, script errors, scroll depth and active time, per page", "Web addresses without query strings. Heatmaps and recordings stay in Clarity"],
    access: "Read-only, with a Clarity Data Export token for each site, added in the dashboard. No shared token",
  },
  {
    id: "bing", name: "Bing Webmaster Tools", status: "Connected", group: "Data sources",
    summary: "Search performance from Bing, shown next to your Google data.",
    reads: ["Your verified Bing sites", "Clicks, impressions, click-through rate and average position by day, query and page"],
    access: "Read-only, with your own Bing Webmaster API key added in the dashboard. No shared key",
  },
];

export const INTEGRATION_GROUPS = ["Data sources", "AI models", "Account"];
